export default {
  dtInventory: {
    align: 'left',
    fixed: false,
    t: 'stock.adjustment.done.label.dtInventory',
    render: true,
    type: 'datetime',
  },
  ldap: {
    align: 'left',
    fixed: false,
    t: 'stock.adjustment.done.label.ldap',
    render: true,
    type: 'general',
  },
  dsBranch: {
    align: 'left',
    fixed: false,
    t: 'stock.adjustment.done.label.dsBranch',
    render: false,
    type: 'general',
  },
  cdLm: {
    align: 'left',
    fixed: false,
    t: 'stock.adjustment.done.label.cdLm',
    render: true,
    type: 'general',
  },
  cdEan: {
    align: 'left',
    t: 'stock.adjustment.done.label.ean',
    render: true,
    type: 'general',
    customWidth:200,
  },
  dsProduct: {
    align: 'left',
    t: 'stock.adjustment.done.label.dsProduct',
    render: true,
    type: 'general',
  },
  dsLot: {
    align: 'left',
    t: 'rotativeInventory.dsLot',
    render: true,
    type: 'general',
  },
  section: {
    align: 'left',
    t: 'stock.adjustment.done.label.section',
    render: false,
    type: 'general',
  },
  subsection: {
    align: 'left',
    t: 'stock.adjustment.done.label.subsection',
    render: true,
    type: 'general',
  },
  type: {
    align: 'left',
    t: 'stock.adjustment.done.label.type',
    render: true,
    type: 'general',
  },
  subtype: {
    align: 'left',
    t: 'stock.adjustment.done.label.subtype',
    render: true,
    type: 'general',
  },
  variations: {
    align: 'left',
    t: 'stock.adjustment.done.label.variation',
    render: true,
    type: 'general',
  },

  nuTop: {
    align: 'center',
    t: 'stock.adjustment.done.label.top',
    render: true,
    type: 'generalShowZero',
  },
  inAvs: {
    align: 'center',
    t: 'stock.adjustment.done.label.avs',
    render: true,
    type: 'index',
  },
  c50: {
    align: 'right',
    t: 'stock.adjustment.done.label.c50',
    render: true,
    type: 'general',
  },
  qtDifference: {
    align: 'right',
    t: 'stock.adjustment.done.label.qtDifference',
    render: true,
    type: 'general',
  },
  c50Counted: {
    align: 'right',
    t: 'stock.adjustment.done.label.c50Counted',
    render: true,
    type: 'general',
  },
  qtPercentage: {
    align: 'right',
    t: 'stock.adjustment.done.label.qtPercentage',
    render: true,
    type: 'percentage_without_limit',
  },
  vlDifference: {
    align: 'right',
    t: 'stock.adjustment.done.label.adjustmentValue',
    render: true,
    type: 'currency',
  },
  dsJustification: {
    align: 'left',
    t: 'stock.adjustment.done.label.dsJustification',
    render: true,
    type: 'general',
  },
  manager: {
    align: 'left',
    t: 'stock.adjustment.done.label.manager',
    render: true,
    type: 'general',
  },
  dsStatus: {
    align: 'center',
    t: 'stock.adjustment.done.label.tpStatus',
    render: true,
    type: 'general',
  },
  integrated: {
    align: 'center',
    t: 'stock.adjustment.done.label.integrated',
    render: true,
    type: 'general',
  },
  warehouse: {
    align: 'left',
    t: 'stock.adjustment.done.label.warehouse',
    render: true,
    type: 'general',
  },
}
